(($, Drupal) => {
  Drupal.behaviors.parnersSlider = {
    attach: function attach() {
      $('.partners-swiper').once('add').each(function (index) {
        const parentEl = $(this).parent('.our-partners');
        const arrowPrev = parentEl.find('.swiper-button-prev').get(0);
        const arrowNext = parentEl.find('.swiper-button-next').get(0);
        const pagination = parentEl.find('.swiper-pagination').get(0);

        const swiper = new Swiper(this, {
          spaceBetween: 20,
          pagination: {
            el: pagination,
            clickable: true,
          },
          navigation: {
            nextEl: arrowNext,
            prevEl: arrowPrev,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2,
            },
            800: {
              slidesPerView: 3,
            },
            1440: {
              slidesPerView: 4,
            },
          },
        });
      });
    },
  };
})(jQuery, Drupal);
